module.exports = __webpack_public_path__ + "static/img/production_02.21d97ab8.jpg";